import { colorType, colorWithOrderType } from './type'

export const colorSort = <TColor extends colorType>(colors: TColor[]) => {
  // 特に何もしない（が、sizeSortに揃えるために定義している）
  return colors
}

export const colorSortWithOrder = (colors: colorWithOrderType[]) => {
  return colorSort(colors).sort((a, b) => a.order - b.order)
}
